import { render, staticRenderFns } from "./DashboardPendingNewsCard.vue?vue&type=template&id=4271ee80"
import script from "./DashboardPendingNewsCard.vue?vue&type=script&lang=js"
export * from "./DashboardPendingNewsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports